import React, { useEffect, useState } from "react";
import "../App.css";
import { Routes, Route } from "react-router-dom";
import Homepage from "../PublicPages/homepage";
import SchoolPage from "../PublicPages/schoolPage";
import CoursePage from "../PublicPages/coursePage";
import PlacementPage from "../PublicPages/placementPage";
import RegisterPage from "../PublicPages/registerPage";
import AlumniPage from "../PublicPages/alumniPage";
import AboutUsPage from "../PublicPages/aboutUsPage";
import BlogPage from "../PublicPages/blogPage";
import SingleBlogPage from "../PublicPages/SingleBlogPage";
import AllEventsPage from "../PublicPages/allEventsPage";
import ContactPage from "../PublicPages/contactUsPage";
import HiringPage from "../PublicPages/hiringPage";
import ResultPage from "../PublicPages/resultPage";
import Parameter from "../PublicPages/faculty/Parameter";
import Publication from "../PublicPages/faculty/Publication";
import SingleEvent from "../components/event/singleEvent";
import Ragging from "../PublicPages/ragging";
import Login from "../AdminPages/form/login";
import { SchoolContex } from "../Helper/Contex";
import api from "../API/api";
import StudentBlogUpload from "../components/studentBlog/upload";
import StudentLogin from "../components/student_register/login";
import StudentDash from "../components/student_register/student_dash";
import StudentBlog from "../components/student_register/studentBlog";
import RegisterStudent from "../PublicPages/registerStudent";
import PageNotFound from "../PublicPages/404";

const PublicInterface = () => {
  const [schools, setSchools] = useState();
  const [courses, setAllCourse] = useState();
  useEffect(() => {
    getSchools();
  }, []);

  const getSchools = () => {
    api
      .getSchools()
      .then((res) => {
        setSchools(res.data.schools);
        setAllCourse(res.data.allCourse);
      })
      .catch((err) => {
        // console.log(err.response);
      });
  };

  return (
    <>
      <SchoolContex.Provider value={{ schools, courses }}>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/school/:school/:id" element={<SchoolPage />} />
          <Route path="/course/:name" element={<CoursePage />} />
          <Route path="/placement" element={<PlacementPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/alumni" element={<AlumniPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/:slug" element={<SingleBlogPage />} />
          <Route path="/allEvents" element={<AllEventsPage />} />
          <Route path="/hiring" element={<HiringPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/faculty/:school/:id" element={<Parameter />} />
          <Route path="/Publication" element={<Publication />} />
          <Route path="/singleEvent" element={<SingleEvent />} />
          <Route path="/studentBlogUpload" element={<StudentBlogUpload />} />
          <Route path="/Ragging" element={<Ragging />} />
          <Route path="/StudentLogin" element={<StudentLogin />} />
          <Route path="/StudentDash" element={<StudentDash />} />
          <Route path="/StudentBlog" element={<StudentBlog />} />
          <Route path="/RegisterStudent" element={<RegisterStudent />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="*" element={<PageNotFound />} /> */}
        </Routes>
      </SchoolContex.Provider>
    </>
  );
};

export default PublicInterface;
